/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-02-14 00:00:00
 *
 *******************************************************/
// @flow

import {
  SI_GET_ALL_THEMES_REQUEST,
  SI_GET_ALL_THEMES_SUCCESS,
  SI_GET_ALL_THEMES_FAILURE,
  SIThemeState,
  SIThemeAction
} from 'stores/flow-type/shopify-integration/theme.type';

const initialState: SIThemeState = {
  getAllThemesLoading: false,
  allThemes: []
};

const shopifyIntegrationThemeReducers = (
  state: SIThemeState = initialState,
  action: SIThemeAction
) => {
  switch (action.type) {
    case SI_GET_ALL_THEMES_REQUEST:
      return { ...state, getAllThemesLoading: true, getAllThemesSuccess: false };
    case SI_GET_ALL_THEMES_SUCCESS: {
      const { data = [] } = action.payload;
      return {
        ...state,
        getAllThemesLoading: false,
        getAllThemesSuccess: true,
        error: undefined,
        allThemes: data
      };
    }
    case SI_GET_ALL_THEMES_FAILURE:
      return {
        ...state,
        getAllThemesLoading: false,
        getAllThemesSuccess: false,
        error: action.payload
      };

    default:
      return state;
  }
};
export default shopifyIntegrationThemeReducers;
